import React from 'react'
import { Button, Dropdown as SemanticDropdown, Form, Input, Modal } from 'semantic-ui-react'

import { searchDropdownOptions } from 'libs/dropdown-search'
import ErrorText from 'shared/components/forms/ErrorText'

interface MemberOption {
  key: number
  value: number
  text: string
  content?: React.ReactNode
}

interface TeamMemberGroupModalProps {
  title: string
  saveLabel: string
  groupName: string
  selectedMemberIds: number[]
  memberOptions: MemberOption[]
  isSaving: boolean
  isLoadingMembers: boolean
  nameError: string
  onGroupNameChange: (name: string) => void
  onMembersChange: (ids: number[]) => void
  onSave: () => void
  onClose: () => void
}

export default function TeamMemberGroupModal({
  title,
  saveLabel,
  groupName,
  selectedMemberIds,
  memberOptions,
  isSaving,
  isLoadingMembers,
  nameError,
  onGroupNameChange,
  onMembersChange,
  onSave,
  onClose,
}: TeamMemberGroupModalProps) {
  return (
    <Modal open onClose={onClose} size="tiny">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <Form id="group-modal-form" onSubmit={onSave} noValidate>
          <Form.Field error={Boolean(nameError)}>
            <label htmlFor="group-name-input">Group name</label>
            <Input
              id="group-name-input"
              value={groupName}
              onChange={(e) => onGroupNameChange(e.target.value)}
            />
            {nameError && <ErrorText>{nameError}</ErrorText>}
          </Form.Field>
          <Form.Field>
            <label>Select team members</label>
            <SemanticDropdown
              placeholder="Select team members"
              fluid
              multiple
              search={searchDropdownOptions}
              selection
              loading={isLoadingMembers}
              disabled={isLoadingMembers}
              options={memberOptions}
              value={selectedMemberIds}
              onChange={(_, data) => onMembersChange(data.value as number[])}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" onClick={onClose}>
          Cancel
        </Button>
        <Button
          primary
          type="submit"
          form="group-modal-form"
          disabled={isSaving}
          loading={isSaving}
        >
          {saveLabel}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/TeamMemberGroupModal/index.tsx